import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const paymentAdvanceStatus = {
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  canceled: 'Cancelado',
};

export const paymentAdvanceStatusOptions = strategyToOptions(paymentAdvanceStatus);
